<!-- eslint-disable no-unused-vars -->
<template>
  <div class="content-container">
    <!-- Search Component -->

    <div class="das-form-container">
      <div class="das-form-group">
        <div class="das-form-row align-end">
          <div class="das-form-col col-3">
            <div class="das-form-input">
              <div class="label">Đoàn</div>
              <select-with-search-table
                style="width: 100%"
                :rows="checkoutGroupOptions"
                :dropdown-width="400"
                :columns="selectSearchCol1"
                :search-fields="['group_name']"
                :is-remove-btn="true"
                :value="groupCheckoutId"
                :selected-index-field-value="groupCheckoutId"
                index-field="id"
                @selectionChanged="onSearchGroupChange"
              >
                <template v-slot:value="{ selectedValue: selectedData }">
                  {{ selectedData?.group_name }}
                </template>
              </select-with-search-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="false"
        dom-layout="scroll"
        :auto-select-first-row="false"
        :rows="rows"
        class="agGrid"
        @selectionChanged="selectionChange"
      />
    </div>
    <div class="button-containers mb-0">
      <!-- <button
        :disabled="!isRowSelected"
        class="btn primary small outline"
        @click="editRow"
      >
        {{ $t('button.modify') }}
      </button> -->
      <button
        :disabled="!isRowSelected"
        class="btn primary small"
        @click="onSetMaster"
      >
        {{ $t('button.setMaster') }}
      </button>
      <button
        :disabled="!isRowSelected"
        class="btn primary small"
        @click="onCheckoutGroup"
      >
        {{ $t('button.groupCheckout') }}
      </button>
      <button
        :disabled="!groupCheckoutId"
        class="btn primary small"
        @click="downloadExcel"
      >
        {{ $t('button.downloadExcel') }}
      </button>
    </div>
    <!--  -->
    <el-dialog
      :title="$t('dialog.titleCheckoutGroupEdit')"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required|max:20" name="Họ">
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('dialog.firstName') }}
                    </div>
                    <input v-model="submitForm.first_name" type="text" />
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider rules="required|max:20" name="Tên">
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('dialog.lastName') }}
                    </div>
                    <input v-model="submitForm.last_name" type="text" />
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required|max:20" name="Giới tính">
                  <div class="das-form-input">
                    <div class="label required">{{ $t('dialog.gender') }}</div>
                    <el-select v-model="submitForm.sex">
                      <el-option :value="1" label="Nam"></el-option>
                      <el-option :value="2" label="Nữ"></el-option>
                      <!-- <option>Không công khai</option> -->
                    </el-select>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider rules="required|max:20" name="Danh xưng">
                  <div class="das-form-input">
                    <div class="label required">{{ $t('dialog.name') }}</div>
                    <input v-model="submitForm.name" type="text" />
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required|max:20" name="Sinh nhật">
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('dialog.birthday') }}
                    </div>
                    <SingleCalendar v-model="submitForm.birth" />
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider rules="required|max:20" name="Địa chỉ 1">
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('dialog.address1') }}
                    </div>
                    <input v-model="submitForm.address_1" type="text" />
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required" name="Địa chỉ 2">
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('dialog.address2') }}
                    </div>
                    <input v-model="submitForm.address_2" type="text" />
                  </div>
                </validation-provider>
              </div>
            </div>
            <!-- <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required|max:20" name="Mã">
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('dialog.marketSegment') }}
                    </div>
                    <select v-model="item.market_seg_desc">
                      <option>Demo 1</option>
                      <option>Demo 2</option>
                    </select>
                  </div>
                </validation-provider>
              </div>
            </div> -->
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small outline"
            @click="updateRow"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small outline" @click="addRow">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// eslint-disable-next-line
import bus from '@/utils/bus'
import { downloadFile } from '@/utils/file-handler'
// eslint-disable-next-line no-unused-vars
import { getCode, addCode, updateCode, deleteCode } from '@/api/common/code'
import {
  getCheckoutGroup,
  checkoutGroupMaster,
  getCheckoutGroupList,
  editCheckoutGroup,
  // eslint-disable-next-line no-unused-vars
  checkoutGroup,
  downloadGroupCheckoutList
} from '@/api/cashier_service/checkoutGroup'
// eslint-disable-next-line no-unused-vars
import {
  cardRoomCheckoutApi,
  checkoutCustomer
} from '@/api/cashier_service/postTransaction'
import { CellRenderCheckboxReadonly } from '@/utils/cellRenders'
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCheckboxReadonly
  },
  data() {
    return {
      rowSelected: null,
      isRowSelected: false,
      loading: false,
      isEdit: false,
      dialogFormVisible: false,
      groupCheckoutId: null,
      checkoutGroupOptions: [],
      submitForm: {
        first_name: null,
        last_name: null,
        sex: null,
        name: null,
        birth: null,
        address_1: null,
        address_2: null,
        id: null
        // code: null,
        // desc: null
      },
      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: this.$t('grid.column.bookingCode'),
          field: 'sub_booking_code',
          tooltipField: 'sub_booking_code',
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.master'),
          field: 'master',
          cellRenderer: 'CellRenderCheckboxReadonly',
          cellClass: 'grid-cell-align-center',
          maxWidth: 120
        },
        // {
        //   headerName: this.$t('grid.column.confirmCode'),
        //   field: 'confirm_code',
        //   tooltipField: 'confirm_code',
        //   maxWidth: 150
        // },
        {
          headerName: this.$t('grid.column.groupCode'),
          field: 'booking_code',
          tooltipField: 'booking_code',
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.lastName'),
          field: 'last_name',
          tooltipField: 'last_name',
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.firstName'),
          field: 'first_name',
          tooltipField: 'first_name',
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.customerLevel'),
          field: 'customer_level',
          tooltipField: 'customer_level',
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.roomNumber'),
          field: 'room_num',
          tooltipField: 'room_num',
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.roomLevel'),
          field: 'room_level',
          tooltipField: 'room_level',
          minWidth: 150,
          flex: 1
          // maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.comeDate'),
          field: 'arrive_date'
          // valueGetter: param => {
          //   if (param?.data?.arrive_date) {
          //     return this.$displayDate(param.data.arrive_date)
          //   } else {
          //     return null
          //   }
          // }
        },
        {
          headerName: this.$t('grid.column.departDate'),
          field: 'depart_date'
          // valueGetter: param => {
          //   if (param?.data?.depart_date) {
          //     return this.$displayDate(param.data.depart_date)
          //   } else {
          //     return null
          //   }
          // }
        }
      ],
      selectSearchCol1: [
        {
          headerName: 'Mã nhóm',
          field: 'group_code',
          flex: 1
        },
        {
          headerName: 'Tên nhóm',
          field: 'group_name',
          flex: 1
        },
        {
          headerName: 'Tên công ty',
          field: 'agent_name',
          flex: 1
        }
      ],
      rows: []
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetInfo()
    }
  },
  async mounted() {
    await this.getcheckoutGroupOptions()
    // this.attachData()
  },
  methods: {
    onReset() {
      this.groupCheckoutId = null
      this.groupId = null
      this.rows = []
    },
    selectionChange() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      // Object.assign(this.item, row)
      this.rowSelected = row
      this.isRowSelected = true
    },
    checkSurPlus() {
      let data = true
      this.rows.forEach(item => {
        if (!isNaN(item?.surplus) && Number(item?.surplus) !== 0) {
          this.$message({
            message: this.$t('errorMsg.surplusError'),
            type: 'error'
          })
          data = false
        }
      })
      return data
    },
    async onCheckoutGroup() {
      if (!this.checkRowSelected()) return
      // if (!this.checkSurPlus()) return
      this.$vxConfirm(this.$t('alert.groupCheckoutMaster'), async () => {
        const gridApi = this.$refs.agGrid.gridApi
        const rows = gridApi.getSelectedRows().map(item => item.id)
        const data = {
          ids: rows
        }
        await checkoutCustomer(data)
          .then(async res => {
            this.groupId = null
            const data = await getCheckoutGroupList(this.groupCheckoutId)
            if (data.data?.length === 0) {
              await this.getcheckoutGroupOptions()
            }
            const message = res.message
            this.dialogFormVisible = false
            this.$message({
              type: 'success',
              message: this.$t(`successMsg.${message}`)
            })
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          })
          .finally(() => {
            this.attachData()
          })

        await cardRoomCheckoutApi()
      })
    },
    checkRowSelected() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      if (row) {
        return true
      } else {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectCustomerRow')
        })
        return false
      }
    },
    async onSearchGroupChange(val) {
      this.groupCheckoutId = val?.id
      if (this.groupCheckoutId) this.attachData()
      else {
        this.rows = []
      }
    },
    async getcheckoutGroupOptions() {
      await getCheckoutGroup()
        .then(async res => {
          const data = res.data
          this.checkoutGroupOptions = data ?? []
          // const message = res.message
          // this.$message({
          //   type: 'success',
          //   message: this.$t(`successMsg.${message}`)
          // })
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          // const message = error.response?.data?.message || 'default'
          // this.$message({
          //   type: 'error',
          //   message: this.$t(`errorMsg.${message}`)
          // })
        })
    },
    onSetMaster() {
      // validate row select
      if (!this.checkRowSelected()) return
      this.$vxConfirm(this.$t('alert.setMasterConfirm'), async () => {
        const params = {
          groupId: this.groupCheckoutId,
          bookingId: this.rowSelected.id
        }
        await checkoutGroupMaster(params)
          .then(async res => {
            const message = res.message
            await getCheckoutGroupList(this.groupCheckoutId)
            this.dialogFormVisible = false
            this.$message({
              type: 'success',
              message: this.$t(`successMsg.${message}`)
            })
            this.attachData()
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          })
      })
    },
    async addRow() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      await addCode(this.item)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    editRow() {
      if (!this.checkRowSelected()) return
      const gridApi = this.$refs.agGrid.gridApi
      const rowSelected = gridApi.getSelectedRows()[0]
      Object.assign(this.submitForm, rowSelected)
      this.isEdit = true
      this.dialogFormVisible = true
    },
    async updateRow() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      await editCheckoutGroup(this.submitForm)
        .then(async res => {
          const message = res.message
          this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async deleteRow() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      if (!row) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
        return false
      }
      this.$vxConfirm(this.$t('alert.groupCheckoutMaster'), async () => {
        const data = {
          ids: [row.id]
        }
        await deleteCode(data)
          .then(async res => {
            const message = res.message
            await this.attachData()
            this.dialogFormVisible = false
            this.$message({
              type: 'success',
              message: this.$t(`code.${message}`)
            })
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: message
            })
          })
      })
    },
    async downloadExcel() {
      bus.$emit('startLoader', { msg: '' })
      const params = {
        id: this.groupCheckoutId
      }
      await downloadGroupCheckoutList(params)
        .then(res => {
          downloadFile(res, 'Danh sách trả phòng đoàn.xlsx')
          this.$message({
            type: 'success',
            message: this.$t('successMsg.downloadSuccessful')
          })
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.downloadError')
          })
          console.log(err)
        })
        .finally(() => {
          bus.$emit('endLoader')
        })
    },
    async attachData() {
      const data = await getCheckoutGroupList(this.groupCheckoutId)
      this.rows = data?.data || []
      this.isRowSelected = false
    },
    resetInfo() {
      this.$nullValueInObj(this.item)
    }
  }
}
</script>

<style lang="scss"></style>
